export default function(status, action, store = {}) {
  return {
    type: action,
    status,
    store
  };
}



// WEBPACK FOOTER //
// ./src/redux/action_creators/not_found_status_action_creator.js